/* Gravur-MAX Produktseite (Redesign): Schritte, Preis, Kaufbereich, Vertrauen. Nur Darstellung, keine Formularlogik. */
(function(){
if(window.__gmPdp)return;
window.__gmPdp=true;
function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
function $(s,r){return (r||document).querySelector(s);}
function step(title,value,opt){
var d=document.createElement('div');
d.className='gm-step';
d.innerHTML='<span class="gm-step__n" aria-hidden="true"></span><span class="gm-step__t">'+title+(opt?' <span class="gm-step__o">(optional)</span>':'')+'</span>'+(value?'<span class="gm-step__v">'+value+'</span>':'');
return d;
}
var ICON={
truck:'<path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="7" cy="17" r="1.8" fill="none" stroke="currentColor" stroke-width="1.6"/><circle cx="17" cy="17" r="1.8" fill="none" stroke="currentColor" stroke-width="1.6"/>',
clock:'<circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M12 7.5V12l3 2" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
tag:'<path d="M3.5 12.5l8-8H20v8.5l-8 8z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="16" cy="8" r="1.4" fill="currentColor"/>',
back:'<path d="M9 7L4.5 11.5 9 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 11.5h9a5 5 0 010 10h-3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
check:'<path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>',
bolt:'<path d="M13 3L5 13.5h6L10 21l8-10.5h-6z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>'
};
function icon(k){return '<svg class="gm-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false">'+ICON[k]+'</svg>';}
var EMOJI=/^[\s☀-➿️‍]*(?:[\uD83C-\uDBFF][\uDC00-\uDFFF][️‍]*)*\s*/;

function run(){
document.body.classList.add('gm-pdp');
var info=$('.product__info-container');
if(!info)return;

/* Preis: Ersparnis */
var reg=$('.price--on-sale .price__sale s.price-item--regular',info),sale=$('.price--on-sale .price-item--sale',info);
if(reg&&sale&&!$('.gm-save',info)){
var a=parseFloat(reg.textContent.replace(/[^\d,]/g,'').replace(',','.')),b=parseFloat(sale.textContent.replace(/[^\d,]/g,'').replace(',','.'));
if(a>b&&b>0)sale.insertAdjacentHTML('afterend','<span class="gm-save">−'+Math.round((1-b/a)*100)+' %</span>');
}

/* Schritt: Motiv */
var mot=$('variant-selects-cust.two-grid-option-swatch',info);
if(mot&&!mot.previousElementSibling?.classList.contains('gm-step')){
var sel='';
mot.querySelectorAll('a.mo-item').forEach(function(x){if(x.getAttribute('href').split('?')[0]===location.pathname){var t=x.querySelector('.item-title');sel=t?t.textContent.trim():'';x.classList.add('is-current');x.setAttribute('aria-current','true');}});
mot.parentNode.insertBefore(step('Motiv wählen',sel),mot);
var mt=$('.product-motion-title',mot);if(mt)mt.classList.add('gm-sr');
}
/* Schritt: Set */
var set=$('.variant-option-v3',info);
if(set){
var cur='';
set.querySelectorAll('input[type=radio]').forEach(function(r){var on=r.value.split('?')[0]===location.pathname||r.checked;var l=set.querySelector('label[for="'+r.id+'"]');if(l)l.classList.toggle('is-current',on);if(on&&l)cur=(l.innerText||'').split('\n').map(function(s){return s.trim();}).filter(function(s){return s&&!/SALE|€/.test(s);})[0]||cur;});
set.parentNode.insertBefore(step('Set wählen',cur),set);
var vt=$('.variant-title-con',set);if(vt)vt.classList.add('gm-sr');
}

/* Hinweis zur Personalisierung in den Konfigurator */
function moveNote(){
var cfg=$('.gm-cfg');
if(!cfg)return;
info.querySelectorAll('.product__richtext_block').forEach(function(b){
if(!/Wichtiger Hinweis/i.test(b.textContent)||b.closest('.gm-note'))return;
var d=document.createElement('details');
d.className='gm-note';
d.innerHTML='<summary>Was kann graviert werden?</summary>';
var head=b.querySelector('strong,b,h3,h4');
if(head&&/Wichtiger Hinweis/i.test(head.textContent))head.classList.add('gm-sr');
d.appendChild(b);
var panels=$('.gm-panels',cfg);
cfg.insertBefore(d,panels?panels.nextSibling:null);
});
}
moveNote();
document.addEventListener('gm:cfg-ready',moveNote);

/* Zubehoer */
var bt=$('.bundle_related_title',info);
if(bt&&$('.bundle-products-wrapper',info)){bt.textContent='';bt.appendChild(step('Passt dazu','',true));}
/* Zubehoer: Button statt Mengenfeld, nutzt die Plus/Minus-Logik des Themes */
info.querySelectorAll('.bundle-products-wrapper').forEach(function(w){
if(w.querySelector('.gm-add'))return;
var img=w.querySelector('a img');
if(img)img.src=img.src.replace(/_(small|compact|thumb|\d+x)(\.\w+)/,'_400x$2');
var plus=w.querySelector('.bundle_plus'),minus=w.querySelector('.bundle_minus'),inp=w.querySelector('.bundle_item_qty');
if(!plus||!minus||!inp)return;
var tp=w.querySelector('.bundle-products-title-price');
if(tp)tp.insertAdjacentHTML('beforeend','<p class="gm-add__hint">Kommt zusammen mit deiner Bestellung in den Warenkorb.</p>');
var b=document.createElement('button');
b.type='button';
b.className='gm-add';
function sync(){var on=+inp.value>0;b.setAttribute('aria-pressed',on?'true':'false');b.innerHTML=on?icon('check')+' Hinzugefügt':'+ Mit in den Warenkorb';w.classList.toggle('is-added',on);}
b.addEventListener('click',function(){
if(+inp.value>0){var g=0;while(+inp.value>0&&g++<20)minus.click();}
else plus.click();
setTimeout(sync,30);
});
inp.addEventListener('change',sync);
w.appendChild(b);
sync();
});

/* Lieferung */
var inv=$('.product__inventory',info);
if(inv&&!$('.gm-ico',inv))inv.insertAdjacentHTML('afterbegin',icon('bolt'));

/* Vertrauen */
info.querySelectorAll('.product__richtext_block').forEach(function(b){
if(!/Versandkostenfrei|Rückgabe/i.test(b.textContent))return;
b.classList.add('gm-trust');
b.querySelectorAll('p').forEach(function(p){
if(p.querySelector('.gm-ico'))return;
var t=p.textContent;
var k=/Versand/i.test(t)?'truck':/Lieferzeit|Werktag/i.test(t)?'clock':/Rabatt|%/i.test(t)?'tag':/Rückgabe|Rückgaberecht/i.test(t)?'back':'check';
if(p.firstChild&&p.firstChild.nodeType===3)p.firstChild.textContent=p.firstChild.textContent.replace(EMOJI,'');
p.insertAdjacentHTML('afterbegin',icon(k));
});
});

/* Schritte nummerieren */
function number(){var i=0;info.querySelectorAll('.gm-step__n').forEach(function(n){n.textContent=++i;});}
number();
document.addEventListener('gm:cfg-ready',number);
}
ready(function(){try{run();}catch(e){if(window.console)console.warn('gm-pdp',e);}});
})();